<!--
     Copyright (c) 2024 Broadcom. All Rights Reserved.
     Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
     and/or its subsidiaries.
-->
<clr-checkbox-container>
    <clr-checkbox-wrapper *ngFor="let item of items">

        <input type="checkbox"
               clrCheckbox
               #input
               *ngIf="item.value !== 'EMPTY'"
               [id]="item.value"
               [value]="item.value"
               [name]="item.label"
               [(ngModel)]="item.selected"
               (ngModelChange)="onCheckboxChecked()"/>
        <label [for]="item.value"
               [ngClass]="{'divider': item.value === 'EMPTY'}">
            <ng-container *ngIf="item.value !== 'EMPTY'">
                {{ item.label }}
            </ng-container>
        </label>
    </clr-checkbox-wrapper>
</clr-checkbox-container>

<button type="button"
        class="btn btn-sm btn-outline"
        (click)="onButtonClick()"
        *ngIf="!!buttonText">
    {{ buttonText | vtranslate }}
</button>
